import {BaseDTO} from '../../common/models/BaseDTO';

export class FileDTO extends BaseDTO {
  fileId: bigint;
  name: string;
  file: any;
  extension: string;
  description: string;
}
